export const WHATS_NEW_DISMISS_KEY = 'whatsNewDismissedMajorReleaseId';

export function shouldAutoOpenWhatsNew(
  latestMajorReleaseId: number | null,
  showPopup: boolean,
  isAuthenticated: boolean,
): boolean {
  if (!latestMajorReleaseId) {
    return false;
  }

  if (isAuthenticated) {
    return !!showPopup;
  }

  const dismissed = localStorage.getItem(WHATS_NEW_DISMISS_KEY);
  return String(latestMajorReleaseId) !== dismissed;
}
